import { faComment } from "@fortawesome/free-solid-svg-icons";
import { isDefinedString } from "et3-type-guards";
import {
  SEARCH_BY_INPUT_USER_ID,
  USER_SEARCH_BY_ENTRIES
} from "../../../../../../constants/picker-entries-constants";
import getUserAdvancedStore from "../../../../../../stores/user-store/advanced-store";
import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import ET3Radio from "../../../../../../core/et3-input/et3-radio";
import Et3TextInput from "../../../../../../core/et3-input/et3-text-input";
import Et3Margin from "../../../../../../core/et3-ui/ET3Margin";

const OptionForm = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { unitX, colors, unitY } = theme;
  const userAdvancedStore = getUserAdvancedStore();
  const ifInputTypeUserID =
    getUserAdvancedStore().searchByInput.get() === SEARCH_BY_INPUT_USER_ID;
  const inputLabel = isDefinedString(
    getUserAdvancedStore().advancedSearchInput.get()
  )
    ? getUserAdvancedStore().advancedSearchInput.get()
    : getUserAdvancedStore().getInputPlaceholder.get();

  // Checking if searchInput is now PhoneNumber to Be Able to do the Validation
  const selectedOption = USER_SEARCH_BY_ENTRIES.find(
    (option) => option.value === userAdvancedStore.searchByInput.get()
  );
  const isPhoneNumberOption =
    selectedOption && selectedOption.value === "phoneNumber";
  const isProfileID = selectedOption && selectedOption.value === "profileId";

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      withShadow={false}
      width={1500}
      height={155}
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <ET3Radio
        options={USER_SEARCH_BY_ENTRIES}
        value={userAdvancedStore.searchByInput.get()}
        onChoose={(value) => {
          userAdvancedStore.advancedSearchInput.set("");
          userAdvancedStore.setSearchByInput(`${value}`);
        }}
        style={{
          width: 1450 * unitX
        }}
      />
      <Et3Margin top={15} bottom={0} left={0} right={0} />
      <Et3TextInput
        size="MEDIUM"
        withShadow={true}
        type={!ifInputTypeUserID ? "text" : "number"}
        icon={faComment}
        label={getUserAdvancedStore().getInputPlaceholder.get()}
        placeHolder={inputLabel}
        value={getUserAdvancedStore().advancedSearchInput.get()}
        onChoose={(value) => {
          getUserAdvancedStore().handleOnChooseInputAdvanced(
            value,
            isPhoneNumberOption,
            ifInputTypeUserID,
            isProfileID
          );
        }}
        onBlur={() => {}}
        onEnter={() => getUserAdvancedStore().getUserData(true)}
        style={{
          width: 280 * unitX,
          height: 95 * unitY
        }}
      />
    </ET3Div>
  );
});

export default OptionForm;
